module.exports = __webpack_public_path__ + "img/logins2.png";